import React, { useEffect } from "react";
import {
    Avatar,
    Badge,
    Button,
    CardContent,
    Fade,
    Grid,
    IconButton,
    ListItem,
    makeStyles,
    Modal,
    Paper,
    Typography,
} from "@material-ui/core";
import { usePerson } from "../../viewmodel/hooks/getPerson";
import Icon from "./svg/NextIcon";
import CloseIcon from "@material-ui/icons/Close";
import { useTranslation } from "react-i18next";
import routes from "../../utils/routes.json";
import apiRoutes from "../../utils/apiRoutes.json";
import { Link } from "react-router-dom";
import { PersonAdd } from "@material-ui/icons";
import { Remove } from "@material-ui/icons";
import api from "../../utils/api";
import { useProfile } from "../../viewmodel/hooks/getProfile";
import { getUserInfo } from "../../viewmodel/providers/userInfo";
import PersonAddDisabledIcon from '@material-ui/icons/PersonAddDisabled';


const useStyles = makeStyles((theme) => ({
    avatar: {
        width: "110px",
        height: "110px",
    },
    avatarsGrid: {
        maxWidth: "500px",
    },
    friend: {
        display:"flex",
        width: "100%",
    },
    badge: {
        backgroundColor: "#FF5A00",
        borderRadius: "50%",
        color: "#fff",
    },
    centerVertically: {
        margin: "auto 0",
    },
    marginCard: {
        marginLeft: "20px",
    },
    icon: {
        marginLeft: "auto",
        marginTop: "auto",
        marginBottom: "auto",
    },
    item: {
        display: "flex",
        flexDirection: "row",
        border: "0px solid rgba(0,0,0,0.12)",
        borderRadius: "0px",
    },
    modal: {
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        ["@media (min-width: 780px)"]: {
            transform: "scale(1.3)",
        },
    },
    paper: {
        backgroundColor: theme.palette.background.paper,
        boxShadow: theme.shadows[5],
    },
    innerSpacing: {
        padding: theme.spacing(0, 4, 2),
    },
    blackButton: {
        backgroundColor: theme.palette.primary.main,
        width: "100%",
        "&:hover": {
            background: theme.palette.primary.main,
        },
    },
    challengeButton: {
        backgroundColor: theme.palette.primary.main,
        marginTop: "10px",
        width: "100%",
        "&:hover": {
            background: theme.palette.primary.main,
        },
    },
    button: {
        color: "lightgrey",
        width: "100%",
        height: "50px",
        textAlign: "left",
        alignSelf: "start",
    },
    fullWidth: {
        width: "100%",
    },
    blackText: {
        color: "black",
    },
    centerHorizontal: {
        marginLeft: "auto",
        marginRight: "auto",
    },
    middleGrid: {
        maxWidth: "800px",
    },
    stats: {
        textAlign: "center",
    },
    close: {
        width: "1.5em",
        height: "1.5em",
    },
    cardContentLessSpace: {
        paddingTop: "0",
    },
    size: {
        transform: "scale(1.2)",
    },
}))

type PersonProps = {
    id: string;
    personName: string;
    personCountry?: string;
    personCountryAcronym?: string;
    bagde?: boolean;
    path?: string;
    challengeButton?: boolean;
}

export default function Person(
    { id, personName, personCountry, personCountryAcronym, bagde, path, challengeButton }: PersonProps): JSX.Element {
    const classes = useStyles();
    const { t } = useTranslation();

    const [open, setOpen] = React.useState(false);
    //const categoryID = ["17","18","19","20","21"]

    const [person] = usePerson(personName, personCountry, personCountryAcronym);
    const [state, setProfileUser] = useProfile();
    useEffect(() => {
        getUserInfo(id, setProfileUser);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    const challengePath = `${path || routes.replay}?playerName=${person.name}`;

    function handleOpen(event: React.MouseEvent<HTMLDivElement, MouseEvent>) {
        event.stopPropagation();
        event.preventDefault();
        setOpen(true);
    }

    function handleClose(event: any) {
        event.stopPropagation();
        event.preventDefault();
        setOpen(false);
    }

    function addFriend (){
        api.post(apiRoutes.addFriend, {"friend_id": id}).then(() => {
            api.put("/add_friend", {
                user: id,
                message: JSON.stringify({ message: "Pedido de amizade de:" }),
            });
        })
    }

    function removeFriend (){
        api.post(apiRoutes.removeFriend, {"friend_id": id});
    }


    const avatar = bagde ? (
        <Badge
            badgeContent={"vs"}
            overlap="circle"
            anchorOrigin={{ vertical: "top", horizontal: "left" }}
            classes={{ badge: classes.badge }}
            className={classes.centerVertically}
        >
            <Avatar onClick={(e) => handleOpen(e)}>
                ?
            </Avatar>
        </Badge>
    ) : (
        <Avatar onClick={(e) => handleOpen(e)}>
            ?
        </Avatar>
    );

    return (
        <> 
        <div className={`${classes.friend}`}>
            <IconButton className={`${classes.size}`} color="primary" aria-label="personRemove" onClick={ () => removeFriend()}>
                <PersonAddDisabledIcon />
            </IconButton>
            <Link to={{
                pathname: routes.matchfriends_categories,
                state: {
                    opponentId: id,
                    confirm: false,
                }
            }}>
                {/*<Button color="primary" classes={{ root: classes.fullWidth }} onClick={() => sendMatchFriend()}>*/}
                <ListItem className={classes.item} style={{ paddingBottom: "16px" }}>
                    {avatar}
                    <Typography variant="h4" className={`${classes.blackText} ${classes.marginCard}`}>
                        {person.name}
                    </Typography>
                    <IconButton className={classes.icon} disabled>
                        <Icon />
                    </IconButton>
                    <Modal
                        className={classes.modal}
                        open={open}
                        onClose={(e) => handleClose(e)}
                        onClick={(e) => {
                            e.preventDefault();
                            e.stopPropagation();
                        }}
                    >
                        <Fade in={open}>
                            <div className={classes.paper}>
                                <Grid
                                    container direction="row" justify="flex-end"
                                >
                                    <IconButton onClick={(e) => handleClose(e)}>
                                        <CloseIcon classes={{ root: classes.close }} />
                                    </IconButton>
                                </Grid>
                                <div className={classes.innerSpacing}>

                                    <CardContent classes={{ root: classes.cardContentLessSpace }}>
                                        <Grid
                                            container direction="row" justify="space-around"
                                            className={`${classes.centerHorizontal} ${classes.avatarsGrid}`}
                                        >
                                            <Avatar className={`${classes.avatar}`}>?</Avatar>
                                        </Grid>

                                        <Grid container direction="row" justify="space-evenly" classes={{ root: classes.centerHorizontal }}>
                                            <Typography variant="h4">
                                                {person.name}
                                            </Typography>
                                        </Grid>
                                        <Grid container direction="row" justify="space-evenly" classes={{ root: classes.centerHorizontal }}>
                                            <Typography variant="h5">
                                                {person.country}
                                            </Typography>
                                        </Grid>
                                    </CardContent>

                                    <Grid
                                        container
                                        direction="row"
                                        justify="space-between"
                                        className={`${classes.centerHorizontal} ${classes.middleGrid}`}
                                    >
                                        <Paper
                                            elevation={0}
                                            className={`${classes.stats}`}
                                        >
                                            <Avatar className={`${classes.blackText} ${classes.centerHorizontal}`}>
                                                10
                                            </Avatar>
                                            <Typography variant="body2">
                                                {t("game-result.xp")}
                                            </Typography>
                                        </Paper>
                                        <Paper elevation={0} className={`${classes.stats}`}>
                                            <Avatar className={`${classes.blackText} ${classes.centerHorizontal}`}>
                                                50000
                                            </Avatar>
                                            <Typography variant="body2">
                                                {t("game-result.points")}
                                            </Typography>
                                        </Paper>
                                        <Paper elevation={0} className={`${classes.stats}`}>
                                            <Avatar className={`${classes.blackText} ${classes.centerHorizontal}`}>
                                                99
                                            </Avatar>
                                            <Typography variant="body2">
                                                {t("game-result.level")}
                                            </Typography>
                                        </Paper>
                                    </Grid>
                                </div>
                            </div>
                        </Fade>
                    </Modal>
                </ListItem>
                {/*</Button>*/}
            </Link>
            </div> 
        </>
    );
}
